<small class="debug">{{me}}</small>
@if (_ready) {
  <div style="width: 100%;height: 100%;">
    <highcharts-chart style="display: flex;" [callbackFunction]="chartCallback" [Highcharts]="Highcharts" [options]="chartOptions" (chartInstance)="logChartInstance($event)"></highcharts-chart>
  </div>
}

@if (!_ready) {
  <div>
    <app-loading [@inOutAnimation] [size]="'50px'" [style]="{'margin-top': '150px'}"></app-loading>
  </div>
}
